import { Component, HostBinding, OnDestroy } from '@angular/core';
import { deleteJsonLd } from '@box/utils';

@Component({
  selector: 'useful-links-shell',
  templateUrl: './useful-links-shell.page.html',
  styleUrls: ['./useful-links-shell.page.scss']
})
export class UsefulLinksShellPage implements OnDestroy {
  @HostBinding('class') public pageWrapper = 'page-wrapper';

  ngOnDestroy() {
    deleteJsonLd();
  }
}
